import React, { useEffect, useState } from "react";
import { LeaveRequest } from "../types/LeaveRequest";
import { Button, Col, Form, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { StoreState } from "../redux/reducers";
import { useDispatch, useSelector } from "react-redux";
import { fetchHolidays } from "../redux/actions/holidayAction";
import { AppDispatch } from "../redux/store";
import '../styles/TaskFilter.css'

interface Props {
  onSave: (request: LeaveRequest) => void;
  initialData?: LeaveRequest | null;
  clearAfterSubmit: () => void;
  employeeId: string;
}

const initialState: LeaveRequest = {
  id: 0,
  employeeId: "",
  year: new Date().getFullYear().toString(),
  leaveType: "",
  dateList: "",
  totalDays: 0,
  reason: "",
  status: "new",
  approvedBy: "",
};
const monthMap: Record<string, number> = {
  january: 0,
  february: 1,
  march: 2,
  april: 3,
  may: 4,
  june: 5,
  july: 6,
  august: 7,
  september: 8,
  october: 9,
  november: 10,
  december: 11,
};
const LeaveRequestForm: React.FC<Props> = ({
  onSave,
  initialData,
  clearAfterSubmit,
  employeeId,
}) => {
  const [form, setForm] = useState<LeaveRequest>({
    ...initialState,
    employeeId,
  });
  const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
    null,
    null,
  ]);
  const holidays = useSelector((state: StoreState) => state.holiday);
  console.log("holiday", holidays);
  const dispatch = useDispatch<AppDispatch>();

  const holidayDates = holidays.map((h) => {
    return new Date(
      Number(h.year),monthMap[h.month.toLowerCase()],
       Number(h.day),
    );
  });

  const [startDate, endDate] = dateRange;

  useEffect(() => {
    if (initialData) {
      setForm(initialData);

      if (initialData.dateList) {
        const dates = initialData.dateList.split(" to ");
        if (dates.length === 2) {
          const start = new Date(dates[0]);
          const end = new Date(dates[1]);
          setDateRange([start, end]);
          setForm((prev) => ({
            ...prev,
            employeeId,
            year: new Date().getFullYear().toString(),

            dateList: `${start.toLocaleDateString(
              "en-CA",
            )} to ${end.toLocaleDateString("en-CA")}`,
          }));
        } else if (dates.length === 1) {
          const single = new Date(dates[0]);
          setDateRange([single, null]);
          setForm((prev) => ({
            ...prev,
            employeeId,
            year: new Date().getFullYear().toString(),

            dateList: `${single.toLocaleDateString("en-CA")}`,
          }));
        }
      }
    } else {
      setForm({
        ...initialState,
        employeeId,
        year: new Date().getFullYear().toString(),
      });
    }
  }, [initialData, employeeId]);

  useEffect(() => {
    dispatch(fetchHolidays());
  }, [dispatch]);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.dateList) {
      alert("Please select a valid date range.");
      return;
    }

    onSave(form);
    setForm({
      ...initialState,
      employeeId,
      year: new Date().getFullYear().toString(),
    });
    setDateRange([null, null]);
    clearAfterSubmit();
    console.log(form);
  };

  const handleClear = () => {
    // setForm(initialState);
    setForm({
      ...initialState,
      employeeId,
      year: new Date().getFullYear().toString(),
    });
    setDateRange([null, null]);
  };

  return (
    <div>
      <Form onSubmit={handleSubmit}>
        {/* <Form.Group controlId="employeeId">
          <Form.Label>
            EmployeeID <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            name="employeeId"
            value={form.employeeId}
            onChange={handleChange}
            placeholder="Employee ID"
            required
          />
        </Form.Group> */}
        {/* 
        <Form.Group controlId="year">
          <Form.Label>
            Year <span className="text-danger">*</span>
          </Form.Label>
          <Form.Select
            name="year"
            value={form.year}
            onChange={handleChange}
            placeholder="year"
            required
          >
            <option value="">Select Year</option>
            {Array.from({ length: 11 }, (_, i) => {
              const y = new Date().getFullYear() - 5 + i;
              return (
                <option key={y} value={y}>
                  {y}
                </option>
              );
            })}
          </Form.Select>
        </Form.Group> */}
        <Row>
          <Col className="form-column">
            <Form.Group controlId="leaveType">
              <Form.Label>
                LeaveType <span className="text-danger">*</span>
              </Form.Label>
              <Form.Select
                name="leaveType"
                value={form.leaveType}
                onChange={handleChange}
                placeholder="leaveType"
                className="form-control"
                required
              >
                <option value="">Select leaveType</option>
                <option value="pl">PL</option>
                <option value="el">EL</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="dateList">
              <Form.Label>
                Date List <span className="text-danger">*</span>
              </Form.Label>
              <br />
              <DatePicker
                selectsRange
                startDate={startDate}
                endDate={endDate}
                onChange={(update) => {
                  //   setDateRange(update as [Date | null, Date | null]);
                  //   if (update[0] && update[1]) {
                  //     const formatted = `${
                  //       update[0].toISOString().split("T")[0]
                  //     } to ${update[1].toISOString().split("T")[0]}`;
                  //     setForm((prev) => ({ ...prev, dateList: formatted }));
                  //   } else if (update[0]) {
                  //     const formatted = `${update[0].toISOString().split("T")[0]}`;
                  //     setForm((prev) => ({ ...prev, dateList: formatted }));
                  //   } else {
                  //     setForm((prev) => ({ ...prev, dateList: "" }));
                  //   }
                  // }}

                  setDateRange(update as [Date | null, Date | null]);
                  if (update[0] && update[1]) {
                    const formatted = `${update[0].toLocaleDateString(
                      "en-CA",
                    )} to ${update[1].toLocaleDateString("en-CA")}`;
                    setForm((prev) => ({ ...prev, dateList: formatted }));
                  } else if (update[0]) {
                    const formatted = `${update[0].toLocaleDateString(
                      "en-CA",
                    )}`;
                    setForm((prev) => ({ ...prev, dateList: formatted }));
                  } else {
                    setForm((prev) => ({ ...prev, dateList: "" }));
                  }
                }}
                dayClassName={(date) => {
                  const isSunday = date.getDay() === 0;

                  const isHoliday = holidayDates.some(
                    (h) => h.toDateString() === date.toDateString(),
                  );

                  if (isSunday || isHoliday) {
                    return "holiday-red";
                  }

                  return "";
                }}
                isClearable
                className="form-control"
                placeholderText="Select date range"
                required
              />
            </Form.Group>
          </Col>
          <Col className="form-column">
            {" "}
            <Form.Group controlId="reason">
              <Form.Label>
                Reason <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                name="reason"
                value={form.reason}
                onChange={handleChange}
                placeholder="Reason"
                required
              />
            </Form.Group>
          </Col>
        </Row>

        {/* <Form.Group controlId="totalDays">
          <Form.Label>
            Total Days <span className="text-danger">*</span>
          </Form.Label>
          <Form.Control
            name="totalDays"
            type="number"
            value={form.totalDays}
            onChange={handleChange}
            placeholder="Total Days"
            required
          />
        </Form.Group> */}

        <div className="form-buttons">
          <Button variant="primary" type="submit">
            {initialData?.id ? "Update" : "Save"}
          </Button>
          <Button
            variant="secondary"
            className="ms-2 ml-2"
            onClick={handleClear}
          >
            Clear
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default LeaveRequestForm;
